import { action } from 'satcheljs';

/**
 * We dispatch this action when the CopilotChatDrawer component finishes rendering hidden in the background,
 * so the orchestrator in owa-suite-header-auto-open can perform the pending auto-open operation if available.
 */
export const onCopilotChatDrawerReady: () => {} = action(
    'onCopilotChatDrawerReady',
    (): {} => ({})
);
